import { QUIZ_QUERY_PARAMS } from '@mc/find-my-classes'
import { paths } from '@mc/paths'

type CtaPathOptions = {
  skipQ1?: boolean
  categories?: number[]
}

export const ctaPath = ({ skipQ1, categories }: CtaPathOptions) => {
  const base = paths.classRecommendations

  const qp = new URLSearchParams()

  if (categories) {
    qp.set(QUIZ_QUERY_PARAMS.SELECTED_CATEGORIES, categories.join(','))
  }
  if (skipQ1) {
    qp.set(QUIZ_QUERY_PARAMS.SKIP_Q1, 't')
  }

  const hasParams = [...qp.keys()].length === 0

  return base + (hasParams ? '' : `?${qp.toString()}`)
}
